module.exports = __webpack_public_path__ + "static/media/rangegif.d0612f15.gif";